import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';

import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';
import { MailsContent } from '@/pageContents/mails/MailsContent';

export const MailsPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Mails | Starjack Backoffice</Helmet>

            <MailsContent />
        </>
    );
};

MailsPage.isProtected = true;
MailsPage.permissions = [Permission.ADMIN];
MailsPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default MailsPage;
